import { render } from "./LoadingState.vue?vue&type=template&id=0270f80f"
import script from "./LoadingState.vue?vue&type=script&lang=js"
export * from "./LoadingState.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__